import { render, staticRenderFns } from "./OnBoardingEdit.vue?vue&type=template&id=df4ec4ee&scoped=true&"
import script from "./OnBoardingEdit.vue?vue&type=script&lang=ts&"
export * from "./OnBoardingEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OnBoardingEdit.vue?vue&type=style&index=0&id=df4ec4ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4ec4ee",
  null
  
)

export default component.exports